var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconParkSolidAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_37",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.6666C15.5324 25.6685 17.05 25.3676 18.4657 24.7811C19.8814 24.1947 21.1673 23.3343 22.2495 22.2494C23.3344 21.1672 24.1948 19.8814 24.7812 18.4656C25.3676 17.0499 25.6686 15.5323 25.6667 13.9999C25.6686 12.4676 25.3676 10.9499 24.7812 9.53421C24.1948 8.1185 23.3344 6.83261 22.2495 5.75043C21.1673 4.66552 19.8814 3.80514 18.4657 3.21871C17.05 2.63228 15.5324 2.33137 14 2.33326C12.4676 2.33137 10.95 2.63228 9.53429 3.21871C8.11858 3.80514 6.83269 4.66552 5.7505 5.75043C4.6656 6.83261 3.80521 8.1185 3.21879 9.53421C2.63236 10.9499 2.33145 12.4676 2.33334 13.9999C2.33145 15.5323 2.63236 17.0499 3.21879 18.4656C3.80521 19.8814 4.6656 21.1672 5.7505 22.2494C6.83269 23.3343 8.11858 24.1947 9.53429 24.7811C10.95 25.3676 12.4676 25.6685 14 25.6666Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.5832C14.3868 21.5832 14.7577 21.4295 15.0312 21.156C15.3047 20.8825 15.4583 20.5116 15.4583 20.1248C15.4583 19.7381 15.3047 19.3671 15.0312 19.0936C14.7577 18.8201 14.3868 18.6665 14 18.6665C13.6132 18.6665 13.2423 18.8201 12.9688 19.0936C12.6953 19.3671 12.5417 19.7381 12.5417 20.1248C12.5417 20.5116 12.6953 20.8825 12.9688 21.156C13.2423 21.4295 13.6132 21.5832 14 21.5832Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V16.3333",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#F7AC6F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidAttention);
export default __webpack_public_path__ + "static/media/icon-park-solid_attention.30253f2fa08c58641498ed0724a3a3b3.svg";
export { ForwardRef as ReactComponent };